import React, { forwardRef } from 'react'

import CheckCircleTwoTone from '@ant-design/icons/CheckCircleTwoTone'
import { Typography, Button } from 'antd'

import { observer } from 'mobx-react-lite'

import { Box, FlexBoxX, FlexBoxY } from 'common/components/boxes'
import { Drawer, DrawerRef } from 'common/components/Drawer'
import { useQuery } from 'common/hooks/use-query'
import { VendorUserRoles } from 'common/server/server_types'

import { useVendorStores } from 'vendor/hooks/use-stores'

const StripeBuyButton = () => {
  const { userStore } = useVendorStores()

  return (
    <FlexBoxX maxHeight="50px" marginBottom="25px">
      <Button
        type="primary"
        onClick={() => {
          window.open('/vendor/billing/checkout_session', '_blank')
        }}
        size="large"
        style={{ width: '100%' }}
        disabled={!userStore.canUseBilling}
      >
        Upgrade
      </Button>
    </FlexBoxX>
  )
}

const ContactAdmins = observer(() => {
  const { vendorSettingStore, userStore } = useVendorStores()

  useQuery(vendorSettingStore.indexUsers)

  const admins = vendorSettingStore.users
    .filter((user) => user.role === VendorUserRoles.ADMIN)
    .map((user) => `${user.first_name ? user.first_name : 'Admin'} - ${user.email}`)

  if (userStore.canUseBilling) {
    return (
      <Box>
        Want to learn more? Email
        <Typography.Text strong>
          <a href="mailto: help@subbase.io"> help@subbase.io </a>
        </Typography.Text>
        or call us directly at <Typography.Text strong>954-684-7939</Typography.Text>
        <Box style={{ textAlign: 'center', marginTop: 20 }}>
          <Typography.Title level={5}>
            <a href="https://www.loom.com/share/3a6ab3e030664f0f83f7c04821341d44" target="_blank" rel="noreferrer">
              Watch Demo
            </a>
          </Typography.Title>
        </Box>
      </Box>
    )
  }

  return (
    <Box marginBottom="25px">
      <Typography.Paragraph>
        Talk to one of your Admins about purchasing seats. Your current admins are:
      </Typography.Paragraph>
      {admins.map((admin, index) => (
        <Typography.Paragraph style={{ marginBottom: 8 }} key={index}>
          {admin}
        </Typography.Paragraph>
      ))}
    </Box>
  )
})

const Features = () => {
  const features = [
    'View historical RFQs and orders',
    'Auto-route customer requests',
    'Customer Service and Win Rate Analytics',
    'Kanban view of RFQs and orders',
    'Track material line items',
  ]

  return (
    <FlexBoxY marginTop="10px" marginLeft="35px" alignItems="flex-start" maxHeight="200px">
      {features.map((feature, index) => {
        return (
          <Box key={index} style={{ marginBottom: '10px' }}>
            <CheckCircleTwoTone twoToneColor="#52c41a" style={{ marginRight: '5px' }} />
            {feature}
          </Box>
        )
      })}
    </FlexBoxY>
  )
}

export const UpgradeDrawer = forwardRef<DrawerRef>((_, ref) => {
  return (
    <Drawer ref={ref} width={378} title={'Upgrade'} forceRender>
      <Box display="flex" flexDirection="column" overflow="auto" width="100%" p={{ _: 12, sm: 16 }}>
        <FlexBoxY maxHeight="100px">
          <Typography.Title level={4}>Upgrade to Premium</Typography.Title>
          <Typography.Title style={{ marginTop: 10 }} level={5}>
            Starting at $200/user/month
          </Typography.Title>
          <Typography.Text>{"Select which users you'd like to upgrade"}</Typography.Text>
        </FlexBoxY>
        <Features />
        <StripeBuyButton />
        <ContactAdmins />
      </Box>
    </Drawer>
  )
})
